var app = {
	windowLoaded: function () {
		_main = this;
		$('.preloader').fadeOut(800, function () {
			$(this).remove();
		});
	},
	windowResized: function () {
		_main = this;
		_main.getViewport();
	},
	windowScrolled: function () {
		_main = this;
		if ($(window).scrollTop() >= $(window).height() * 0.5) {
			$('header').addClass('stuck');
		} else {
			$('header').removeClass('stuck');
		}
	},
	cookies: {
		createCookie: function (name, value, days) {
			_main = app;
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			var expires = "; expires=" + date.toGMTString();
			document.cookie = name + "=" + value + expires + "; path=/";
			(_main.debug) ? console.log('creating cookie: ', name) : '';
		},
		readCookie: function (name) {
			_main = app;
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},
		checkCookies: function () {
			_main = app;
			if (_main.cookies.readCookie(_main.cookieName) != 1) {
				(_main.debug) ? console.log('cookie %s is not created yet', _main.cookieName) : '';
				_main.cookies.notification('show');
			} else {
				(_main.debug) ? console.log('cookie %s already exists', _main.cookieName) : '';
			}
			$('.closeNotification').on('click', function () {
				_main.cookies.createCookie(_main.cookieName, 1, 365);
				_main.cookies.notification('hide');
			});
		},
		notification: function (state) {
			_main = app;
			switch (state) {
				case 'show':
					$('.footer').append('<div class="cookiesNotification"><p>' + _main.messages.cookies + '</p><p class="closeNotification">&times;</p></div>');
					break;
				case 'hide':
					$('.cookiesNotification').fadeOut(300, function () {
						$(this).remove();
					});
					break;
			}
		}
	},
	initMap: function () {
		var maps = $('#mainContent .googlemap');
		_g_map();
		function _g_map() {
			if (maps.length > 0) {
				var apiKey = maps.attr('data-api-key'),
					apiURL;

				if (apiKey) {
					apiURL = 'https://maps.google.com/maps/api/js?key=' + apiKey + ' &sensor=false';
				} else {
					apiURL = 'https://maps.google.com/maps/api/js?sensor=false';
				};

				$.getScript(apiURL, function (data, textStatus, jqxhr) {
					maps.each(function () {
						var current_map = $(this),
							latlng = new google.maps.LatLng(current_map.attr('data-longitude'),
								current_map.attr('data-latitude')),
							point = current_map.attr('data-marker'),

							myOptions = {
								zoom: 14,
								center: latlng,
								mapTypeId: google.maps.MapTypeId.ROADMAP,
								mapTypeControl: false,
								scrollwheel: true,
								draggable: true,
								panControl: true,
								zoomControl: true,
								disableDefaultUI: true
							},

							stylez = [
								{
									featureType: "all",
									elementType: "all",
									stylers: [
										{ saturation: -100 } // <-- THIS
									]
								}
							];

						var map = new google.maps.Map(current_map[0], myOptions);

						var mapType = new google.maps.StyledMapType(stylez, { name: "Grayscale" });
						map.mapTypes.set('Grayscale', mapType);
						map.setMapTypeId('Grayscale');

						var marker = new google.maps.Marker({
							map: map,
							icon: {
								size: new google.maps.Size(59, 69),
								origin: new google.maps.Point(0, 0),
								anchor: new google.maps.Point(0, 69),
								url: point
							},
							position: latlng
						});

						google.maps.event.addDomListener(window, "resize", function () {
							var center = map.getCenter();
							google.maps.event.trigger(map, "resize");
							map.setCenter(center);
						});
					});
				});
			};
		};
	},
	handleNav: function () {
		if (_main.viewport == 'mobile' || _main.viewport == 'tablet') {
			_main.debug ? console.log('nav init') : '';
			var $mobileMenu = $('#nav-aside_menu'),
				$topBarNavigation = $('#top-bar__navigation > ul');

			if (!$mobileMenu && !$topBarNavigation) return;

			var $objBarNavigation = $topBarNavigation.clone();
			$mobileMenu.append($objBarNavigation);
			$mobileMenu.find('li').each(function () {
				if ($(this).is(':has(ul)')) {
					$(this).addClass('is-submenu');
				}
			});
			$(document).one('click', '#nav-aside_menu li.is-submenu', function (e) {
				$(this).toggleClass('is-open');
				return false;
			});

			$('#top-bar__navigation-toggler, .nav-aside__close').on('click', function () {
				console.log('nav trig');
				$('#nav-aside').toggleClass('openedMenu');
			});
		}
	},
	handleScrollArrows: function () {
		var ptBackToTop = $('#js-back-to-top'),
			$window = $(window);

		if (ptBackToTop.length) {
			ptBackToTop.on('click', function (e) {
				$('html, body').animate({
					scrollTop: 0
				}, 500);
				return false;
			});
			$window.scroll(function () {
				$window.scrollTop() > 750 ? ptBackToTop.stop(true.false).addClass('show') : ptBackToTop.stop(true.false).removeClass('show');
			});
		};

		var jsScrollDown = $('#js-scroll-down'),
			scrollDownAnchor = $('#scroll-down-anchor');
		// $window = $(window);

		if (jsScrollDown.length && scrollDownAnchor.length) {
			initbacktotop();
		};
		function initbacktotop() {
			jsScrollDown.on('click', function (e) {
				$('html, body').animate({
					scrollTop: scrollDownAnchor.offset().top
				}, 1000);
				return false;
			});
			$window.scroll(function () {
				$window.scrollTop() > 500 ? jsScrollDown.stop(true.false).addClass('show') : jsScrollDown.stop(true.false).removeClass('show');
			});
		};
	},
	handleSliders: function () {

		(function ($) {
			dataBg('[data-bg]');
			function dataBg(el) {
				$(el).each(function () {
					var $this = $(this),
						bg = $this.attr('data-bg');
					$this.css({
						'background-image': 'url(' + bg + ')'
					});
				});
			};
			var mainSlider = $('.mainSlider');
			if (mainSlider.length) {
				mainslider();
			};
			function mainslider() {
				var $obj = mainSlider;
				// $obj.find('.slide').first().imagesLoaded({
				// 	background: true
				// }, function(){
				// 	setTimeout(function(){
				// 		$obj.parent().find('.loading-content').addClass('disable');
				// 	}, 100);
				// });
				$obj.on('init', function (e, slick) {
					var $firstAnimatingElements = $('div.slide:first-child').find('[data-animation]');
					runAnimation($firstAnimatingElements);
				});
				$obj.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
					var $currentSlide = $('div.slide[data-slick-index="' + nextSlide + '"]');
					var $animatingElements = $currentSlide.find('[data-animation]');
					runAnimation($animatingElements);
				});
				var dataArrow = $obj.data('arrow'),
					dataDots = $obj.data('dots');
				$obj.slick({
					arrows: dataArrow || false,
					dots: dataDots || false,
					autoplay: true,
					autoplaySpeed: 5500,
					fade: true,
					speed: 1000,
					pauseOnHover: false,
					pauseOnDotsHover: true,
					customPaging: function (slider, i) {
						return '<span>' + '0' + (i + 1) + '</span>';
					}
				});
			};
			function runAnimation(elements) {
				var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
				elements.each(function () {
					var $this = $(this),
						$animationType = 'animated ' + $this.data('animation'),
						$animationDelay = $this.data('animation-delay');
					$this.css({
						'animation-delay': $animationDelay,
						'-webkit-animation-delay': $animationDelay
					});
					$this.addClass($animationType).one(animationEndEvents, function () {
						$this.removeClass($animationType);
					});
					if ($this.hasClass('animate')) {
						$this.removeClass('animation');
					}
				});
			};


			var $allVideos = $("iframe[src^='//player.vimeo.com'], iframe[src^='//www.youtube.com'], object, embed"),
				$fluidEl = $("figure");

			$allVideos.each(function () {

				$(this)
					// jQuery .data does not work on object/embed elements
					.attr('data-aspectRatio', this.height / this.width)
					.removeAttr('height')
					.removeAttr('width');

			});

			$(window).resize(function () {

				var newWidth = $fluidEl.width();
				$allVideos.each(function () {

					var $el = $(this);
					$el
						.width(newWidth)
						.height(newWidth * $el.attr('data-aspectRatio'));

				});

			}).resize();


		})(jQuery);
	},
	loadingScreen: function (msg) {
		_main.debug ? console.log('init loading screen') : '';
		$('body').append('<figure class="popMessage">\
            <p>'+ msg + '</p>\
        </figure>\
		<div class="overlay"></div> \
        ');
	},
	popMessage: function (msg) {
		_main = this;
		// ($('.loadingScreen').length())?$('.loadingScreen').fadeOut():'';
		if ($('.popMessage').length) {
			$('.popMessage, .overlay').remove();
		}
		$('body').append('<figure class="popMessage">\
            <p>'+ msg + '</p>\
            <div class="closePop">&times;</div>\
        </figure>\
		<div class="overlay"></div> \
        ');
	},
	events: function () {
		_main = this;

		$('.gotoPDF').on('click', function (e) {
			e.preventDefault();
			console.log('PDF: ', $(this).attr('data-item'));
			_main.ga_event('click', 'Pobierz PDF', $(this).attr('data-item'));
			window.open($(this).attr('href'), '_blank')
		});

		$('.sendForm').on('click', function (e) {
			// _main.ga_event('Click', 'Formularz','Wyślij: '+type);
			e.preventDefault();
			if (_main.visitorType == 'human') {
				_main.sendForm();
			} else {
				_main.debug?console.log('bot trying to send message'):'';
			}
			
			return false;
		});

		$('body').on('click', '.closePop', function () {
			$('.popMessage, .overlay').remove();
		});

		$('body').on('click', '.prevDef', function (e) {
			e.preventDefault();
		});

		$('.gnav li').on('click', function () {
			target = $(this).attr('data-target');
			$("html, body").animate({
				scrollTop: $(target).offset().top
			}, "slow");
			_main.globalNavigation();
		});

		if ($('table').length) {
			$('table').wrap('<div style="overflow: auto;"></div>');
		}
	},
	botOrNot: function () {
		_main = this;
		(_main.debug) ? console.log('bot verification') : '';
		grecaptcha.ready(function () {
			grecaptcha.execute('6LfmzZQUAAAAAAaG6c7BnRvNDYqp0s2gDKL9rUs4', { action: 'homepage' })
				.then(function (token) {
					$.ajax({
						url: base_url + 'bot_or_not',
						type: 'POST',
						data: {
							token: token
						},
					}).done(function (response) {
						// (_main.debug)?console.log('response content: ',response):'';
						(_main.debug) ? console.log('response score: ', response.score) : '';
						if (response.score >= 0.5) {
							(_main.debug) ? console.log('Assuming that you are a human') : '';
							_main.visitorType = 'human';
							$('input[name=url]').attr('value', '');
							$('#contactform').attr('action', base_url + 'wyslij-wiadomosc');
							$('#sendBtn,.sendForm').fadeIn(500);
						} else {
							(_main.debug) ? console.log('Assuming that you are a bot') : '';
							_main.visitorType = 'bot';
							_main.ga_event('Click', 'Wykryto BOTA', 'Wynik: ' + response.score);
						}
					});
				});
		});
	},
	handleFormInputs: function () {
		var $formDefault = $('#mainContent .form-default .form-control:not(select)');
		if ($formDefault.length) {
			$formDefault.focus(function () {
				$(this).parents('.form-group').addClass('focused');
			});

			$formDefault.blur(function () {
				var inputValue = $(this).val();
				if (inputValue == "") {
					$(this).removeClass('filled');
					$(this).parents('.form-group').removeClass('focused');
				} else {
					$(this).addClass('filled');
				};
			});
		};
	},
	sendForm: function () {
		formData = $('.contact-form').serialize();
		_main.loadingScreen(_main.messages.pleaseWait);
		if (_main.visitorType == 'human') {
			$.ajax({
				type: 'POST',
				data: formData,
				// url: base_url + 'send/form',
				url: base_url + 'wyslij-wiadomosc',
				success: function (msg) {
					(_main.debug) ? console.log('ajax success: ', msg) : '';
					if (msg.match("^Error")) {
						(_main.debug) ? console.log('Error while sending e-mail') : '';
						_main.popMessage(_main.messages.sendFormError);
						// _main.ga_event('Error', 'Błąd','Newsletter: nie udało się wysłać');
					} else {
						(_main.debug) ? console.log('E-mail sent') : '';
						_main.popMessage(_main.messages.sendFormSuccess);
					}
					$('form').find("input[type=text], input[type=email], input[type=tel], textarea").val('');
				},
				error: function (msg) {
					(_main.debug) ? console.log('ajax error: ', msg) : '';
					_main.ga_event('Error', 'Błąd', 'Formularz: ajax');
				}
			});
		} else {
			_main.popMessage(_main.messages.youAreBot);
		}
	},
	ga_event: function ($action, $category, $label) {
		_main = this;
		gtag('event', $action, {
			'event_category': $category,
			'event_label': $label
		});
	},
	getBodyId: function () {
		_main = this;
		_main.bodyId = $('body').attr('id');
		(_main.debug) ? console.log('body id: ', _main.bodyId) : '';
		(_main.bodyId == 'contact') ? _main.initMap() : '';
		if (_main.bodyId == 'contact') {
			_main.botOrNot();
			_main.handleFormInputs();
		}
	},
	getViewport: function () {
		_main = this;
		wh = $(window).width();
		if (wh <= _main.breakpointMobile) {
			_main.viewport = 'mobile';
		} else if (wh > _main.breakpointMobile && wh <= _main.breakpointTablet) {
			_main.viewport = 'tablet';
		} else {
			_main.viewport = 'desktop';
		}
		(_main.debug) ? console.log('viewport: ', _main.viewport) : '';
	},
	messages: {
		'sendFormSuccess': 'Dziękujemy, wiadomość została wysłana.',
		'sendFormError': 'Wystąpił błąd podczas wysyłania wiadomości. Prosimy o sprawdzenie poprawności wprowadzonych danych i spróbowanie ponownie.',
		'uknkown': 'Wystąpił nieprzewidziany błąd aplikacji',
		'cookies': 'Na naszej stronie używamy plików cookies w celach statystycznych. Aby dowiedzieć się na czym to polega, kliknij w ten <a href="' + base_url + 'informacje/informacje-prawne#cookies">link</a>.',
		'ajaxError': 'Wystąpił błąd podczas połączenia z serwerem.',
		'pleaseWait': 'Proszę czekać...'
	},
	init: function () {
		_main = this;
		_main.getViewport();
		_main.getBodyId();
		_main.events();
		_main.handleSliders();
		_main.handleNav();
		_main.handleScrollArrows();
		_main.cookies.checkCookies();
	},

	debug: true,
	debugOutput: false,
	viewport: null,
	cookieName: 'KovoStanekWebsitePL',
	visitorType: null,

	globalNavState: false,
	currentVideoState: null,
	bodyClass: null,
	bodyId: null,

	breakpointMobile: 640,
	breakpointTablet: 1100
}

$(document).ready(function () {
	app.init();
});

$(window).on('load', function () {
	app.windowLoaded();
});

$(window).resize(function () {
	app.windowResized();
});

$(document).scroll(function () {
	app.windowScrolled();
});
